const internalServiceRoot = '/api/ArcGIS/';
const geocodeServiceRoot = '/api/ArcGIS/geocode/';

export const GeospatialEndpoints = {
  // Base url for the geocoder search widget
  getGeocodeServiceRoot: () => `${geocodeServiceRoot}`,
  getAddressCandidates: () => `${geocodeServiceRoot}findAddressCandidates`,
  getSuggest: () => `${geocodeServiceRoot}suggest`,

  getReverseGeocode: () => `${internalServiceRoot}reverseGeocode`,
  getGeometryData: () => `${internalServiceRoot}getGeometryData`,
};
